export const skypeUrl = 'https://join.skype.com/invite/AdDbThJOeejF';
export const facebookUrl = 'https://www.facebook.com/people/Lily-Bency/61589120105944/?mibextid=wwXIfr&rdid=tmQq4qql7AQ1oMqe&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1JgNFvy8fk%2F%3Fmibextid%3DwwXIfr';
export const instagramUrl = 'https://www.instagram.com/globaladvisorycorp?igsh=MXQwbmloNzJmdTdweQ==';
export const telegramUrl = 'https://t.me/+447385054407';
export const whatsappUrl = 'https://wa.me/+447385054407';
export const linkedinUrl = 'https://www.linkedin.com/company/offshore-advisory-ltd/';
export const calendlyUrl = 'https://calendly.com/offshoreadvisory-info/30min';
export const email = 'mailto:info@offshoreadvisory.pro';
